module.exports = __webpack_public_path__ + "img/189.d43471fa.gif";